import React from "react";
import Section1 from "./sections/Section1.configurator.tsx";
import Section2 from "./sections/Section2.configurator.tsx";
import Section3 from "./sections/Section3.configurator.tsx";
import Section4 from "./sections/Section4.configurator.tsx";
import Section5 from "./sections/Section5.configurator.tsx";
import Section6 from "./sections/Section6.configurator.tsx";
import Section7 from "./sections/Section7.configurator.tsx";

const ConfiguratorHomepage: React.FC = () => {
  return (
    <>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
    </>
  );
};

export default ConfiguratorHomepage;
